import logo from "../../_asset/bg/zeuslogo.png"
import logo2 from "../../_asset/bg/zeuslogo.png"

export function Logo_1() {
    return (
        <img src={logo} alt="logo1" />
    )
}
export function Logo_2() {
    return (
        <img src={logo2} alt="logo2" />
    )
}